{#if $observationData}
  <div class="weather-current-container">
    <Selector></Selector>
    <div class="weather-current-location muted mb-1">
      {$observationData.dateByName}, {$observationData.time}
    </div>
    <div class="weather-current-text h1">
      {#if $observationData}{$observationData.icon_text_capitalized}{/if}
    </div>
    <div class="weather-current-icon">
      <img
        class="weather-icon img-fluid"
        src="https://img.rtvslo.si/_static/novi/bootstrap/public/img/weather-widget/{displayIcon}.svg"
        alt="{$observationData.icon_text}"
      />
    </div>
    <div class="weather-current-temp h1 font-weight-bold">
      {#if $observationData}{$observationData.temperature}{/if}°
    </div>
    <div class="weather-current-details mt-4 mt-xl-5 row">
      <div class="col-6">
        <svg
          class="weather-details-icon"
          xmlns="http://www.w3.org/2000/svg"
          xml:space="preserve"
          viewBox="0 0 100 100"
          ><path
            fill="currentColor"
            d="M65.8 61.1H13.2c-1.5 0-2.6 1.2-2.6 2.8 0 1.5 1.2 2.8 2.6 2.8h52.6c7.3 0 13.2 6.2 13.2 13.9s-5.9 13.9-13.2 13.9c-7.3 0-13.2-6.2-13.2-13.9 0-1.5-1.2-2.8-2.6-2.8-1.5 0-2.6 1.2-2.6 2.8A19 19 0 0 0 65.8 100c10.2 0 18.4-8.7 18.4-19.4 0-10.8-8.3-19.5-18.4-19.5zM76.3 0c-13 0-23.7 11.2-23.7 25 0 1.5 1.2 2.8 2.6 2.8 1.5 0 2.6-1.2 2.6-2.8 0-10.7 8.3-19.4 18.4-19.4S94.7 14.3 94.7 25a19 19 0 0 1-18.4 19.4H41.8a20 20 0 0 0 5.6-13.9A19 19 0 0 0 29 11.1a18.9 18.9 0 0 0-18.4 19.4c0 1.5 1.2 2.8 2.6 2.8 1.5 0 2.6-1.2 2.6-2.8 0-7.7 5.9-13.9 13.2-13.9 7.3 0 13.2 6.2 13.2 13.9S36.3 44.4 29 44.4H2.6c-1.5 0-2.6 1.2-2.6 2.8C0 48.8 1.2 50 2.6 50h73.7A24.4 24.4 0 0 0 100 25c0-13.8-10.6-25-23.7-25zM29 77.8l-26.3-.3a2.7 2.7 0 0 0-2.6 2.7A2.6 2.6 0 0 0 2.6 83l26.3.3c1.4 0 2.6-1.2 2.6-2.7.1-1.5-1.1-2.8-2.5-2.8z"
          ></path></svg
        >
        <div class="muted mb-2">Hitrost vetra</div>
        <div class="font-weight-bold">
          {$observationData.wind_text}<br />
          {$observationData.wind_speed} km/h
        </div>
      </div>
      <div class="col-6">
        <svg
          class="weather-details-icon"
          xmlns="http://www.w3.org/2000/svg"
          xml:space="preserve"
          viewBox="0 0 100 66"
          ><path
            fill="currentColor"
            d="M50 26.3c1.5 0 2.8-1.2 2.8-2.6V2.6C52.8 1.2 51.5 0 50 0c-1.5 0-2.8 1.2-2.8 2.6v21.1c0 1.5 1.3 2.6 2.8 2.6zM18.4 37.2a3 3 0 0 0 2 .8c.7 0 1.4-.3 2-.8 1.1-1 1.1-2.7 0-3.7L10.2 21.9c-1.1-1-2.9-1-3.9 0a2.5 2.5 0 0 0 0 3.7l12.1 11.6zm78.8 23.5H83.3a32.8 32.8 0 0 0-33.3-29 32.9 32.9 0 0 0-33.3 29H2.8c-1.5 0-2.8 1.2-2.8 2.6S1.2 66 2.8 66H97c1.5 0 2.8-1.2 2.8-2.6s-1-2.7-2.6-2.7zM79.6 38c.7 0 1.4-.3 2-.8l12.2-11.5c1.1-1 1.1-2.7 0-3.7s-2.9-1-3.9 0L77.6 33.5a2.5 2.5 0 0 0 0 3.7c.5.5 1.2.8 2 .8z"
          ></path></svg
        >
        <div class="muted mb-2">Vzhod / Zahod</div>
        <div class="font-weight-bold">
          {$observationData.sunriseHour}<br />
          {$observationData.sunsetHour}
        </div>
      </div>
      <div class="col-12 my-3 my-xl-4"></div>
      <div class="col-6">
        <svg
          class="weather-details-icon"
          xmlns="http://www.w3.org/2000/svg"
          xml:space="preserve"
          viewBox="0 0 78 100"
          ><path
            fill="currentColor"
            d="M41.6 1a4 4 0 0 0-5.2 0C34.9 2.3 0 33.2 0 61.5A38.8 38.8 0 0 0 39 100c21.5 0 39-17.3 39-38.5C78 33.2 43.1 2.3 41.6 1zM39 84.6a3.8 3.8 0 0 1-3.9-3.8c0-2.1 1.7-3.8 3.9-3.8 8.6 0 15.6-6.9 15.6-15.4 0-2.1 1.7-3.8 3.9-3.8s3.9 1.7 3.9 3.8c0 12.7-10.5 23-23.4 23z"
          ></path></svg
        >
        <div class="muted mb-2">Vlažnost</div>
        <div class="font-weight-bold">
          {$observationData.humidity_text}<br />
          {$observationData.humidity}%
        </div>
      </div>
      <div class="col-6">
        <svg
          class="weather-details-icon"
          xmlns="http://www.w3.org/2000/svg"
          xml:space="preserve"
          viewBox="0 0 40 100"
          ><path
            fill="currentColor"
            d="M32.5 63.5V12.8C32.5 5.8 26.9 0 20 0S7.5 5.8 7.5 12.8v50.7a20.9 20.9 0 0 0-7.5 16C0 90.8 9 100 20 100s20-9.2 20-20.5c0-6.2-2.8-12.1-7.5-16zM20 89.7c-5.5 0-10-4.6-10-10.3 0-4.8 3.2-8.7 7.5-9.9V33.3c0-1.4 1.1-2.6 2.5-2.6s2.5 1.1 2.5 2.6v36.3c4.3 1.1 7.5 5.1 7.5 9.9 0 5.6-4.5 10.2-10 10.2zm0-15.3a5 5 0 0 0-5 5.1 5 5 0 0 0 5 5.1 5 5 0 0 0-5-5.1 5 5 0 0 0-5-5.1z"
          ></path></svg
        >
        <div class="muted mb-2">Tlak</div>
        <div class="font-weight-bold">
          {$observationData.presure_text}<br />
          {$observationData.presure} hPa
        </div>
      </div>
    </div>
  </div>
{/if}
<MarkerHolder></MarkerHolder>
<small class="float-right muted"
  >vir: <a
    class="text-light"
    target="_blank"
    href="https://www.gov.si/drzavni-organi/organi-v-sestavi/agencija-za-okolje/"
    >ARSO</a
  ></small
>

<script lang="ts">
  import { get } from "svelte/store";
  import { weatherStore } from "../store";
  const { selectedCity, observationData } = weatherStore;
  import { iconConverter } from "./../services/IconConverter";
  import MarkerHolder from "./MarkerHolder.svelte";
  import Selector from "./Selector.svelte";

  import { utils } from "../services/Utils";

  $: displayIcon = $observationData
    ? utils.getDisplayIcon(
        $observationData.icon,
        $observationData.time,
        $observationData.sunriseHour,
        $observationData.sunsetHour,
      )
    : "";
</script>
